import { client } from '@fhs/client';
import { getCurrentSession } from '@fhs-legacy/frontend/src/remote/auth';
import { ServiceMode } from '@fhs-legacy/frontend/src/state/service-mode';

export const getOrderTimeslots = {
  queryKey: ['order-timeslots'],
  queryFn: async () => client.queries.orderTimeslots(await _getAuthMode()).then(res => res.data),
};

export const getLegacyUserPaymentInformationQuery = {
  queryKey: ['legacy-user-payment-information'],
  queryFn: async () =>
    client.queries.legacyUserPaymentInformation(await _getAuthMode()).then(res => res.data),
};

export const selectStore = {
  mutationFn: async ({
    storeNumber,
    serviceMode,
  }: {
    storeNumber: string;
    serviceMode: ServiceMode;
  }) => {
    return client.mutations.selectStore(
      {
        storeNumber,
        serviceMode,
      },
      await _getAuthMode()
    );
  },
};

// ----------------------------------------------------------------
// private
// ----------------------------------------------------------------

const _getAuthMode = async (): Promise<any> => {
  const session = await getCurrentSession();
  if (session) {
    return {
      authToken: 'Bearer ' + session.getIdToken().getJwtToken(),
      authMode: 'lambda',
    };
  }

  return { authMode: 'apiKey' };
};
